import redirectsData from '@/middleware/redirects.json';

export default function ({ redirect, route }) {
    // redirects
    if (process.server) {
        const redirectUrl = redirectsData.data.find((data) => data.old === route.fullPath);

        if (redirectUrl) {
            return redirect(301, redirectUrl.new);
        }
    }
}
